import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BusyService, CommonSettings } from 'epay-library';

@Component({
  selector: 'emp-cc-fort-point',
  templateUrl: './empccfort-point.component.html'
})
export class EMPCCFortPointComponent implements OnInit {
  @Input() creditCardUrl = '';
  @Input() stateCode = '';
  @Input() amount = 0;
  @Input() transactionId = '';

  environment = "";

  @ViewChild('ccForm', { static: false }) ccForm: any;

  constructor(private busyservice: BusyService) {
    this.environment = CommonSettings.Environment;
  }

  ngOnInit() {
    this.busyservice.increment('Redirecting....');

    if (this.environment === "Prod" || this.environment === "prod"){
      //this.creditCardUrl = "https://childsupportpaymentportal.com";
      this.creditCardUrl = "https://sandbox.childsupportpaymentportal.com";
    }
    else {
      this.creditCardUrl = "https://sandbox.childsupportpaymentportal.com";
    }
    
    //console.log('CCFORM ', this.ccForm);
    //console.log('cc url ', this.creditCardUrl);
    //console.log('state code ', this.stateCode);
    //console.log('amount', this.amount);
    //console.log('transID ', this.transactionId);
  }

  ngAfterViewChecked() {
    if (this.ccForm !== undefined) {
      this.ccForm.nativeElement.submit();
    }
  }
}
